import { apiClient } from './apiClient';
import { Subscription, SubscriptionList } from '../types/subscription';
import { captureHandledError } from '../utilities/datadog';

// #region getSubscription
// get_subscription()
export const getSubscription = async (
  org_id?: string,
  user_id?: string
): Promise<SubscriptionList | null> => {
  try {
    const params = new URLSearchParams();
    if (user_id) params.set('user_id', user_id);
    if (org_id) params.set('org_id', org_id);

    const response = await apiClient(`/subscription?${params.toString()}`, {
      method: 'GET',
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const body = await response.json();
      captureHandledError('Failed to fetch subscription', body, {
        org_id,
        user_id,
      });
      return null;
    }
  } catch (error) {
    captureHandledError('Error fetching subscriptions for org', error, {
      org_id,
      user_id,
    });
    throw error;
  }
};
// #endregion

// #region getCRMSubscription
export const getCRMSubscription = async (
  org_id: string,
): Promise<Subscription | null> => {
  try {
    const response = await apiClient(`/crm-import-field?org_id=${org_id}`, {
      method: 'GET',
    });
    if (response.ok) {
      const data = await response.json()
      return data;
    } else {
      const body = await response.json();
      captureHandledError('Failed to fetch subscription', body, {
        org_id,
      });
      return null;
    }
  } catch (error) {
    captureHandledError('Error fetching subscriptions for org', error, {
      org_id,
    });
    throw error;
  }
}
// #endregion

// #region updateSubscription
// patch_subscription()
export const updateSubscription = async (
  subscription_data: {
    default_permission?: string;
    user_permission?: string;
    subscription_type: string;
    created_by?: string;
  },
  org_id: string,
  user_id?: string,
  user_email?: string
): Promise<Subscription | null> => {
  try {
    const params = new URLSearchParams({ org_id: org_id });
    if (user_id) params.append('user_id', user_id);
    if (user_email) params.append('user_email', user_email);
    const response = await apiClient(`/subscription?${params.toString()}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(subscription_data),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const body = await response.json();
      captureHandledError('Failed to update subscription (non-OK)', body, {
        org_id,
        user_id,
      });
      return null;
    }
  } catch (error) {
    captureHandledError('updateSubscription error', error, { org_id, user_id });
    throw error;
  }
};
// #endregion
